import api from '../api'; // Assuming 'api' is a configured Axios instance

/**
 * Reset a user's password.
 *
 * @param {string} newPassword - The new password.
 * @param {string} token - The token for validating the password reset request.
 * @return {Promise<Object>} - The response from the API.
 * @throws {Error} - If the request or reset fails.
 */
const resetPassword = async (newPassword, token) => {
  // Define your API endpoint
  const endpoint = process.env.REACT_APP_API_ENDPOINT + "/api/user/resetPassword";

  try {
    // Send POST request to the server with the new password and token
    console.log({
      new_password: newPassword,
      token: token
    })
    const response = await api.post(endpoint, {
      new_password: newPassword,
      token: token
    });

    // Return the response data
    return response.data;

  } catch (error) {
    // Log and rethrow the error to be handled by the calling code
    console.error('Error while resetting password:', error);
    throw error;
  }
};

export default resetPassword;
